export const supportedCurrencies = [
  'bitcoin',
  //   'lightning',
  'ethereum',
  'eth_base',
  'usdc_solana',
  'usdc_erc20',
  'usdc_base',
  'usdc_polygon',
  'usdc_arbitrum',
  'usdt_erc20',
  'usdt_polygon',
  'usdt_trc20',
  'usdt_bsc',
  //   'litecoin',
  'dogecoin',
  'dash',
];

export interface currenyInfo {
  chain: string;
  contract: string;
}

export const currenyInfo = {
  bitcoin: {
    chain: 'btc',
    contract: '',
  },
  lightning: {
    chain: 'lightning',
    contract: '',
  },
  ethereum: {
    chain: 'eth',
    contract: '',
  },
  eth_base: {
    chain: 'base',
    contract: '',
  },
  usdc_solana: {
    chain: 'sol',
    contract: 'EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v',
  },
  usdc_erc20: {
    chain: 'eth',
    contract: '0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48',
  },
  usdc_base: {
    chain: 'base',
    contract: '0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913',
  },
  usdc_polygon: {
    chain: 'matic',
    contract: '0x3c499c542cef5e3811e1192ce70d8cc03d5c3359',
  },
  usdc_arbitrum: {
    chain: 'arbitrum',
    contract: '0xfd086bc7cd5c481dcc9c85ebe478a1c0b69fcbb9',
  },
  usdt_erc20: {
    chain: 'eth',
    contract: '0xdac17f958d2ee523a2206206994597c13d831ec7',
  },
  usdt_polygon: {
    chain: 'matic',
    contract: '0xc2132d05d31c914a87c6611c10748aeb04b58e8f',
  },
  usdt_trc20: {
    chain: 'trx',
    contract: 'TR7NHqjeKQxGTCi8q8ZY4pL8otSzgjLj6t',
  },
  usdt_bsc: {
    chain: 'bsc',
    contract: '0x55d398326f99059ff775485246999027b3197955',
  },
  //   litecoin: {
  //     chain: 'ltc',
  //     contract: ''
  //   },
  dogecoin: {
    chain: 'doge',
    contract: '',
  },
  dash: {
    chain: 'dash',
    contract: '',
  },
};
